// extracted by mini-css-extract-plugin
module.exports = {"coupon":"CouponCode_coupon__FZAV1","couponInputContainer":"CouponCode_couponInputContainer__UI6M8","content":"CouponCode_content__iexnv","button":"CouponCode_button__67bYW"};